export const routeNames = {
  home: "/",
  about: "/aboutus",
  guide: "/guide",

  // Auth routes
  login: "/d/login",
  signUp: "/d/signUp",
  forgetPass: "/d/forgot-password",
  resetPass: "/d/reset-password",
  personalization: "/d/personalization",

  // User routes
  dashboard: "/d/dashboard",
  profile: "/d/profile",
  progress: "/d/progress",
  courseOverview: "/d/course/:courseId",
  interviews: "/d/interviews",
  interview: "/d/interview/:interviewId",
  courseOverview_: "/d/course/",
  courseModule: "/d/module/:courseId",
  courseStudy: "/d/course/study/:courseId",
  courseStudy_: "/d/course/study/",

  // Admin routes
  adminUsers: "/admin/users",
  adminUser: "/admin/user/:id",
  adminUser_: "/admin/user/",
  adminGstForm: "/admin/qstform/:courseId",
  adminGstForm_: "/admin/qstform/",
  adminCourseMgt: "/admin/courses",
  adminEditCourse: "/admin/course/edit",
  // adminAddGst: "/admin/course/add-question/:courseId",
  // adminAddGst_: "/admin/course/add-question/",
  adminCreateCourse: "/admin/create-course",
  adminLogin: "/admin/login",
  adminAdminUsers: "/admin/admin-users",
  adminCourses: "/admin/courses",
  adminCourse: "/admin/course/:courseId",
  adminCourse_: "/admin/course/",
  adminInterviews: "/admin/interviews",
  adminCreateInterview: "/admin/create-interview",
  adminInterview: "/admin/interview/:id",
};


export type RouteName = keyof typeof routeNames;